// src/musicas.js

// Quantidade de músicas em cada categoria
const QTD_CALMO = 5   // ex: calmo1.mp3 até calmo5.mp3
const QTD_EPICO = 5   // ex: epico1.mp3 até epico5.mp3
const QTD_APREENSIVO = 5 // ex: apreensivo1.mp3 até apreensivo5.mp3

// Função auxiliar para gerar lista de caminhos
function gerarLista(prefixo, qtd) {
  return Array.from({ length: qtd }, (_, i) => `/musicas/${prefixo}${i + 1}.mp3`)
}

// Exporta objeto com os gêneros
export const musicas = {
  calmo: gerarLista("calmo", QTD_CALMO),
  epico: gerarLista("epico", QTD_EPICO),
  apreensivo: gerarLista("apreensivo", QTD_APREENSIVO),
}
